import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

class PJModal extends Component<any, any> {

  render() {
    return (
      <div>
        <Modal size={this.props.size} open={this.props.open} onClose={this.props.onClose}>
          {this.props.content}
        </Modal>
      </div>
    )
  }
}

export default PJModal;